<template>
<v-card min-height='300' >
  <v-card-text v-if='loading' >
    <center>
    <v-progress-circular indeterminate
      height='2' size='70' width=2  color='amber' >
    </v-progress-circular><br/><br/>
    Loading
    </center>
  </v-card-text>
  <transition name="fade" mode="out-in" >
  <template >
    <client-details
      v-if='clientId'
      :value='client'
      :is-compact='$vuetify.breakpoint.xs' >
    </client-details>
    <v-alert v-else-if='clientNotFound'
      :value=true type='info' class='ma-0 py-0 caption lighten-1' >
        Unable to find the requested client.
        <v-btn @click='get' >Try again</v-btn>
        <v-btn
          @click="$store.dispatch('SET_SPACE', ['globalDialog', 'ClientList', 'Find a client', { showListInitially: true, withCreate: false, touch: Math.random() }, {clientselected: gotoClient}, $vuetify.breakpoint.xsOnly])" >
          <v-icon class='mr-2' >search</v-icon>
          Search</v-btn>
    </v-alert>
  </template>
  </transition>
</v-card>
</template>
<script type="text/javascript">
import ClientDetails from '@/components/client/ClientDetails'

export default {
  name: 'ClientPage',
  components: {ClientDetails},
  data () {
    return {
      clientNotFound: false
    }
  },
  mounted () {
    let vm = this
    window.setTimeout(() => {
      if (!this.clientId) { vm.clientNotFound = true }
    }, 5000)
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        if (!this.client || !this.client.id) {
          this.searchClients(this.relationshipId)
        }
      }
    },
    userId: {
      immediate: true,
      handler () {
        if (!this.client || !this.client.id) {
          this.searchClients(this.userId)
        }
      }
    },
    clientId () {
      if (!this.clientId) {
        let vm = this
        window.setTimeout(() => { vm.clientNotFound = true }, 1500)
      } else {
        this.clientNotFound = false
      }
    }
  },
  computed: {
    loading () {
      if (this.getClientSearchReq.loading === true) { return true }
      return false
      // if (this.getClientsReq.loading === true) { return true }
    },
    relationshipId () {
      return this.$route.params.relationshipId
    },
    userId () {
      return this.$route.params.id
    },
    clientId () {
      return this.getObjectPath(this.client, 'id')
    },
    client () {
      let vm = this
      let userId = vm.$route.params.id
      let relationshipId = this.relationshipId
      if (relationshipId) {
        return this.getRelationById(relationshipId)
      }
      if (userId) {
        return this.getRelationByClientId(userId)
      }
      // this.$store.getters.clients.find((client) => {
      //   let clientId = vm.getObjectPath(client, 'client.id')
      //   if (clientId) {
      //     return (clientId.toString() === id)
      //   } else {
      //     console.log(client)
      //   }
      // })
    }
  },
  methods: {
    get () {
      if (this.relationshipId) {
        this.searchClients(this.relationshipId)
      } else {
        return this.searchClients(this.userId)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Client.vue?d91e43e8